import { t } from '@lingui/core/macro';
import { type CarWheelPositionText, TireLeadReason } from '@navio/nsdk';
import type { BadgeVariant } from 'noddi-ui-web';
import type { TireLeadSeverity } from './tireLeadReasonCopy';

export const SEVERITY_BADGE_VARIANT: Record<TireLeadSeverity, BadgeVariant> = {
  high: 'destructive',
  medium: 'warning',
  info: 'default'
};

export const getSeverityLabel = (severity: TireLeadSeverity) => {
  switch (severity) {
    case 'high':
      return t`Replace soon`;
    case 'medium':
      return t`Should be replaced`;
    case 'info':
      return t`Offer`;
  }
};

export const getTireLeadReasonLabel = (reason: TireLeadReason) => {
  switch (reason) {
    case TireLeadReason.WORN_TREAD:
      return t`Worn tread`;
    case TireLeadReason.UNEVEN_WEAR:
      return t`Uneven wear`;
    case TireLeadReason.CRACKS_DRY_ROT:
      return t`Cracks in the rubber`;
    case TireLeadReason.SIDEWALL_DAMAGE:
      return t`Sidewall damage`;
    case TireLeadReason.PUNCTURE:
      return t`Puncture`;
    case TireLeadReason.OLD_TIRES:
      return t`Old tires`;
    case TireLeadReason.CUSTOMER_WISH:
      return t`Your request`;
    case TireLeadReason.OTHER:
      return t`Other fault`;
  }
};

export const getTirePositionLabel = (position: CarWheelPositionText) => {
  switch (position) {
    case 'FRONT_LEFT':
      return t`Front left`;
    case 'FRONT_RIGHT':
      return t`Front right`;
    case 'REAR_LEFT':
      return t`Rear left`;
    case 'REAR_RIGHT':
      return t`Rear right`;
    case 'FRONT':
      return t`Front`;
    case 'REAR':
      return t`Rear`;
    default:
      return t`Other tire`;
  }
};
